import { FormEvent, useState } from 'react';
import type { CreateServiceInput, ServiceStatus, ServiceType } from '../types/service.types';

interface ServiceCreateModalProps {
  open: boolean;
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (input: CreateServiceInput) => Promise<unknown>;
}

export function ServiceCreateModal({
  open,
  submitting,
  error,
  onClose,
  onSubmit,
}: ServiceCreateModalProps) {
  const [tenantId, setTenantId] = useState('');
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [type, setType] = useState<ServiceType>('vpn');
  const [status, setStatus] = useState<ServiceStatus>('active');
  const [description, setDescription] = useState('');
  const [metadata, setMetadata] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);

  if (!open) return null;

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const parsedTenantId = Number(tenantId);
    if (!Number.isInteger(parsedTenantId) || parsedTenantId <= 0 || !name.trim() || !slug.trim()) {
      setValidationError('شناسه تننت، نام و شناسه یکتا الزامی هستند.');
      return;
    }

    let parsedMetadata: Record<string, unknown> | undefined;
    if (metadata.trim()) {
      try {
        const value: unknown = JSON.parse(metadata);
        if (!value || Array.isArray(value) || typeof value !== 'object') throw new Error('invalid');
        parsedMetadata = value as Record<string, unknown>;
      } catch {
        setValidationError('فراداده باید یک JSON object معتبر باشد.');
        return;
      }
    }

    setValidationError(null);
    await onSubmit({
      tenant_id: parsedTenantId,
      name: name.trim(),
      slug: slug.trim(),
      type,
      status,
      description: description.trim() || null,
      ...(parsedMetadata ? { metadata: parsedMetadata } : {}),
    });
  }

  return (
    <div className="vania-service-modal-backdrop" role="presentation">
      <form className="vania-service-modal" onSubmit={handleSubmit}>
        <h2 className="vania-service-workspace-card-title">ایجاد سرویس</h2>
        <label>شناسه تننت<input type="number" min="1" value={tenantId} onChange={(event) => setTenantId(event.target.value)} disabled={submitting} required /></label>
        <label>نام سرویس<input value={name} onChange={(event) => setName(event.target.value)} disabled={submitting} required /></label>
        <label>شناسه یکتا<input dir="ltr" value={slug} onChange={(event) => setSlug(event.target.value)} disabled={submitting} required /></label>
        <label>نوع سرویس<select value={type} onChange={(event) => setType(event.target.value as ServiceType)} disabled={submitting}><option value="vpn">VPN</option><option value="gold">Gold</option><option value="saas">SaaS</option><option value="custom">Custom</option></select></label>
        <label>وضعیت<select value={status} onChange={(event) => setStatus(event.target.value as ServiceStatus)} disabled={submitting}><option value="active">فعال</option><option value="inactive">غیرفعال</option><option value="archived">بایگانی شده</option></select></label>
        <label>توضیحات<textarea rows={3} value={description} onChange={(event) => setDescription(event.target.value)} disabled={submitting} /></label>
        <label>فراداده JSON<textarea dir="ltr" rows={3} value={metadata} onChange={(event) => setMetadata(event.target.value)} disabled={submitting} placeholder="{&quot;key&quot;: &quot;value&quot;}" /></label>
        {(validationError || error) && <p className="vania-service-action-error">{validationError || error}</p>}
        <div className="vania-service-workspace-actions">
          <button type="button" className="vania-service-secondary-action" onClick={onClose} disabled={submitting}>انصراف</button>
          <button type="submit" className="vania-service-primary-action" disabled={submitting}>{submitting ? 'در حال ایجاد...' : 'ایجاد سرویس'}</button>
        </div>
      </form>
    </div>
  );
}
